// Copyright (C) 2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Col, Row } from 'antd/lib/grid';
import { CombinedState } from 'reducers';
import JobCard from './job-card';

function JobsContentComponent(): JSX.Element {
    const history = useHistory();
    const jobs = useSelector((state: CombinedState) => state.jobs.current);
    const dimensions = {
        md: 22,
        lg: 18,
        xl: 16,
        xxl: 16,
    };
    const jobsByTask = jobs.reduce((acc: { taskId: number; jobs: any[] }[], job: any) => {
        let taskGroup = acc.find((group) => group.taskId === job.taskId);
        if (!taskGroup) {
            taskGroup = {
                taskId: job.taskId,
                jobs: [],
            };
            acc.push(taskGroup);
        }

        taskGroup.jobs.push(job);
        return acc;
    }, []);

    const openTask = (event: React.MouseEvent, taskId: number): void => {
        const url = `/tasks/${taskId}`;
        if (event.ctrlKey || event.metaKey) {
            window.open(url, '_blank', 'noopener noreferrer');
        } else {
            history.push(url);
        }
    };

    return (
        <Row justify='center' align='middle'>
            <Col className='cvat-jobs-page-list' {...dimensions}>
                {jobsByTask.map((taskGroup: { taskId: number; jobs: any[] }): JSX.Element => (
                    <div key={taskGroup.taskId} className='cvat-jobs-page-task-group'>
                        <div className='cvat-jobs-page-task-group-header'>
                            <a
                                href={`/tasks/${taskGroup.taskId}`}
                                className='cvat-jobs-page-task-group-link'
                                onClick={(event: React.MouseEvent): void => {
                                    event.preventDefault();
                                    openTask(event, taskGroup.taskId);
                                }}
                            >
                                {`Task #${taskGroup.taskId}`}
                            </a>
                            <span>{`${taskGroup.jobs.length} job${taskGroup.jobs.length === 1 ? '' : 's'}`}</span>
                        </div>
                        <div className='cvat-jobs-page-task-group-cards'>
                            {taskGroup.jobs.map((job: any): JSX.Element => (
                                <JobCard job={job} key={job.id} />
                            ))}
                        </div>
                    </div>
                ))}
            </Col>
        </Row>
    );
}

export default React.memo(JobsContentComponent);
